import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

const EnterScore = ({
  comp_id,
  parameters,
  participants,
  scores,
  setScores,
}) => {
  let navigate = useNavigate();
  const [score, setScore] = useState({
    totalScore: 0,
    judge: jwtDecode(localStorage.getItem("judgeauthtoken")).judge.mcjId,
  });

  const [disabled, setDisabled] = useState(false);

  const onChange = (e) => {
    setScore({ ...score, [e.target.name]: e.target.value });
  };

  const onScoreChange = (e) => {
    setScore({
      ...score,
      [e.target.name]: e.target.value,
    });
  };

  const fetchEnteredScores = () => {
    Axios.post(
      "https://ashish.moodi.org/multicity/get_mul_scores",
      {
        competition: comp_id,
        judge: jwtDecode(localStorage.getItem("judgeauthtoken")).judge.mcjId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => setScores(res.data))
      .catch((err) => console.error(err));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    Axios.post(
      "https://ashish.moodi.org/multicity/mul_enter_score",
      {
        competition: comp_id,
        score: score,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (res.data.status === "done") {
          console.log("response", res.data.score);
          console.log("Score", scores);
          setScores((current) => [...current, res.data.score]);
          setScore({
            judge: jwtDecode(localStorage.getItem("judgeauthtoken")).judge
              .mcjId,
          });
          setDisabled(false);
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("judgeauthtoken")) {
      fetchEnteredScores();
    } else {
      navigate("/judge/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <table>
        <thead>
          <tr>
            <th>
              <label htmlFor="team" className="form-label p-2 text-center">
                Slot Number
              </label>
            </th>
            {parameters.map((parameter) => {
              return (
                <th className={`px-3`} key={parameter.mcpId}>
                  <label
                    htmlFor={parameter.parameterName}
                    className="form-label text-center"
                  >
                    {parameter.parameterName} ({parameter.parameterWeightage})
                  </label>
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          <td className={`px-3`}>
            <select
              onChange={onChange}
              name="participant"
              id="team"
              className="form-select"
              required
            >
              <option value={""}>Select the slot number</option>
              {participants.map((participant) => {
                if (
                  scores.find(
                    (element) => element.participant === participant.mcpId
                  )
                ) {
                  return <></>;
                } else {
                  return (
                    <option key={participant.mcpId} value={participant.mcpId}>
                      Slot - {participant.slotNumber}
                    </option>
                  );
                }
              })}
            </select>
          </td>
          {parameters.map((parameter) => {
            return (
              <td className={`px-3`}>
                <input
                  className="form-control w-100 mx-auto"
                  type="number"
                  onChange={onScoreChange}
                  name={parameter.parameterName}
                  id={parameter.parameterName}
                  value={score[parameter.parameterName]}
                  max={parameter.parameterWeightage}
                  required
                />
              </td>
            );
          })}
          <td className={`px-4`}>
            {disabled ? (
              <button
                className="btn btn-primary w-100 mt-3"
                type="submit"
                disabled={disabled}
              >
                <span
                  className="spinner-border spinner-border-sm"
                  aria-hidden="true"
                ></span>
                <span role="status">Saving...</span>
              </button>
            ) : (
              <input type="submit" value="Save" className="btn btn-primary" />
            )}
          </td>
        </tbody>
      </table>
    </form>
  );
};

export default EnterScore;
